"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3148],{

/***/ 66280:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var languageCode = [
    {
        language: "Abkhazian",
        isoCode: "ab"
    },
    {
        language: "Afar",
        isoCode: "aa"
    },
    {
        language: "Afrikaans",
        isoCode: "af"
    },
    {
        language: "Akan",
        isoCode: "ak"
    },
    {
        language: "Albanian",
        isoCode: "sq"
    },
    {
        language: "Amharic",
        isoCode: "am"
    },
    {
        language: "Arabic",
        isoCode: "ar"
    },
    {
        language: "Aragonese",
        isoCode: "an"
    },
    {
        language: "Armenian",
        isoCode: "hy"
    },
    {
        language: "Assamese",
        isoCode: "as"
    },
    {
        language: "Avaric",
        isoCode: "av"
    },
    {
        language: "Avestan",
        isoCode: "ae"
    },
    {
        language: "Aymara",
        isoCode: "ay"
    },
    {
        language: "Azerbaijani",
        isoCode: "az"
    },
    {
        language: "Bambara",
        isoCode: "bm"
    },
    {
        language: "Bashkir",
        isoCode: "ba"
    },
    {
        language: "Basque",
        isoCode: "eu"
    },
    {
        language: "Belarusian",
        isoCode: "be"
    },
    {
        language: "Bengali (Bangla)",
        isoCode: "bn"
    },
    {
        language: "Bihari",
        isoCode: "bh"
    },
    {
        language: "Bislama",
        isoCode: "bi"
    },
    {
        language: "Bosnian",
        isoCode: "bs"
    },
    {
        language: "Breton",
        isoCode: "br"
    },
    {
        language: "Bulgarian",
        isoCode: "bg"
    },
    {
        language: "Burmese",
        isoCode: "my"
    },
    {
        language: "Catalan",
        isoCode: "ca"
    },
    {
        language: "Chamorro",
        isoCode: "ch"
    },
    {
        language: "Chechen",
        isoCode: "ce"
    },
    {
        language: "Chichewa, Chewa, Nyanja",
        isoCode: "ny"
    },
    {
        language: "Chinese",
        isoCode: "zh"
    },
    {
        language: "Chinese (Simplified)",
        isoCode: "zh-Hans"
    },
    {
        language: "Chinese (Traditional)",
        isoCode: "zh-Hant"
    },
    {
        language: "Chuvash",
        isoCode: "cv"
    },
    {
        language: "Cornish",
        isoCode: "kw"
    },
    {
        language: "Corsican",
        isoCode: "co"
    },
    {
        language: "Cree",
        isoCode: "cr"
    },
    {
        language: "Croatian",
        isoCode: "hr"
    },
    {
        language: "Czech",
        isoCode: "cs"
    },
    {
        language: "Danish",
        isoCode: "da"
    },
    {
        language: "Divehi, Dhivehi, Maldivian",
        isoCode: "dv"
    },
    {
        language: "Dutch",
        isoCode: "nl"
    },
    {
        language: "Dzongkha",
        isoCode: "dz"
    },
    {
        language: "English",
        isoCode: "en"
    },
    {
        language: "Esperanto",
        isoCode: "eo"
    },
    {
        language: "Estonian",
        isoCode: "et"
    },
    {
        language: "Ewe",
        isoCode: "ee"
    },
    {
        language: "Faroese",
        isoCode: "fo"
    },
    {
        language: "Fijian",
        isoCode: "fj"
    },
    {
        language: "Finnish",
        isoCode: "fi"
    },
    {
        language: "French",
        isoCode: "fr"
    },
    {
        language: "Fula, Fulah, Pulaar, Pular",
        isoCode: "ff"
    },
    {
        language: "Galician",
        isoCode: "gl"
    },
    {
        language: "Gaelic (Scottish)",
        isoCode: "gd"
    },
    {
        language: "Gaelic (Manx)",
        isoCode: "gv"
    },
    {
        language: "Georgian",
        isoCode: "ka"
    },
    {
        language: "German",
        isoCode: "de"
    },
    {
        language: "Greek",
        isoCode: "el"
    },
    {
        language: "Greenlandic",
        isoCode: "kl"
    },
    {
        language: "Guarani",
        isoCode: "gn"
    },
    {
        language: "Gujarati",
        isoCode: "gu"
    },
    {
        language: "Haitian Creole",
        isoCode: "ht"
    },
    {
        language: "Hausa",
        isoCode: "ha"
    },
    {
        language: "Hebrew",
        isoCode: "he"
    },
    {
        language: "Herero",
        isoCode: "hz"
    },
    {
        language: "Hindi",
        isoCode: "hi"
    },
    {
        language: "Hiri Motu",
        isoCode: "ho"
    },
    {
        language: "Hungarian",
        isoCode: "hu"
    },
    {
        language: "Icelandic",
        isoCode: "is"
    },
    {
        language: "Ido",
        isoCode: "io"
    },
    {
        language: "Igbo",
        isoCode: "ig"
    },
    {
        language: "Indonesian",
        isoCode: "id, in"
    },
    {
        language: "Interlingua",
        isoCode: "ia"
    },
    {
        language: "Interlingue",
        isoCode: "ie"
    },
    {
        language: "Inuktitut",
        isoCode: "iu"
    },
    {
        language: "Inupiak",
        isoCode: "ik"
    },
    {
        language: "Irish",
        isoCode: "ga"
    },
    {
        language: "Italian",
        isoCode: "it"
    },
    {
        language: "Japanese",
        isoCode: "ja"
    },
    {
        language: "Javanese",
        isoCode: "jv"
    },
    {
        language: "Kalaallisut, Greenlandic",
        isoCode: "kl"
    },
    {
        language: "Kannada",
        isoCode: "kn"
    },
    {
        language: "Kanuri",
        isoCode: "kr"
    },
    {
        language: "Kashmiri",
        isoCode: "ks"
    },
    {
        language: "Kazakh",
        isoCode: "kk"
    },
    {
        language: "Khmer",
        isoCode: "km"
    },
    {
        language: "Kikuyu",
        isoCode: "ki"
    },
    {
        language: "Kinyarwanda (Rwanda)",
        isoCode: "rw"
    },
    {
        language: "Kirundi",
        isoCode: "rn"
    },
    {
        language: "Kyrgyz",
        isoCode: "ky"
    },
    {
        language: "Komi",
        isoCode: "kv"
    },
    {
        language: "Kongo",
        isoCode: "kg"
    },
    {
        language: "Korean",
        isoCode: "ko"
    },
    {
        language: "Kurdish",
        isoCode: "ku"
    },
    {
        language: "Kwanyama",
        isoCode: "kj"
    },
    {
        language: "Lao",
        isoCode: "lo"
    },
    {
        language: "Latin",
        isoCode: "la"
    },
    {
        language: "Latvian (Lettish)",
        isoCode: "lv"
    },
    {
        language: "Limburgish ( Limburger)",
        isoCode: "li"
    },
    {
        language: "Lingala",
        isoCode: "ln"
    },
    {
        language: "Lithuanian",
        isoCode: "lt"
    },
    {
        language: "Luga-Katanga",
        isoCode: "lu"
    },
    {
        language: "Luganda, Ganda",
        isoCode: "lg"
    },
    {
        language: "Luxembourgish",
        isoCode: "lb"
    },
    {
        language: "Manx",
        isoCode: "gv"
    },
    {
        language: "Macedonian",
        isoCode: "mk"
    },
    {
        language: "Malagasy",
        isoCode: "mg"
    },
    {
        language: "Malay",
        isoCode: "ms"
    },
    {
        language: "Malayalam",
        isoCode: "ml"
    },
    {
        language: "Maltese",
        isoCode: "mt"
    },
    {
        language: "Maori",
        isoCode: "mi"
    },
    {
        language: "Marathi",
        isoCode: "mr"
    },
    {
        language: "Marshallese",
        isoCode: "mh"
    },
    {
        language: "Moldavian",
        isoCode: "mo"
    },
    {
        language: "Mongolian",
        isoCode: "mn"
    },
    {
        language: "Nauru",
        isoCode: "na"
    },
    {
        language: "Navajo",
        isoCode: "nv"
    },
    {
        language: "Ndonga",
        isoCode: "ng"
    },
    {
        language: "Northern Ndebele",
        isoCode: "nd"
    },
    {
        language: "Nepali",
        isoCode: "ne"
    },
    {
        language: "Norwegian",
        isoCode: "no"
    },
    {
        language: "Norwegian bokm\xe5l",
        isoCode: "nb"
    },
    {
        language: "Norwegian nynorsk",
        isoCode: "nn"
    },
    {
        language: "Nuosu",
        isoCode: "ii"
    },
    {
        language: "Occitan",
        isoCode: "oc"
    },
    {
        language: "Ojibwe",
        isoCode: "oj"
    },
    {
        language: "Old Church Slavonic, Old Bulgarian",
        isoCode: "cu"
    },
    {
        language: "Oriya",
        isoCode: "or"
    },
    {
        language: "Oromo (Afaan Oromo)",
        isoCode: "om"
    },
    {
        language: "Ossetian",
        isoCode: "os"
    },
    {
        language: "Pāli",
        isoCode: "pi"
    },
    {
        language: "Pashto, Pushto",
        isoCode: "ps"
    },
    {
        language: "Persian (Farsi)",
        isoCode: "fa"
    },
    {
        language: "Polish",
        isoCode: "pl"
    },
    {
        language: "Portuguese",
        isoCode: "pt"
    },
    {
        language: "Punjabi (Eastern)",
        isoCode: "pa"
    },
    {
        language: "Quechua",
        isoCode: "qu"
    },
    {
        language: "Romansh",
        isoCode: "rm"
    },
    {
        language: "Romanian",
        isoCode: "ro"
    },
    {
        language: "Russian",
        isoCode: "ru"
    },
    {
        language: "Sami",
        isoCode: "se"
    },
    {
        language: "Samoan",
        isoCode: "sm"
    },
    {
        language: "Sango",
        isoCode: "sg"
    },
    {
        language: "Sanskrit",
        isoCode: "sa"
    },
    {
        language: "Serbian",
        isoCode: "sr"
    },
    {
        language: "Serbo-Croatian",
        isoCode: "sh"
    },
    {
        language: "Sesotho",
        isoCode: "st"
    },
    {
        language: "Setswana",
        isoCode: "tn"
    },
    {
        language: "Shona",
        isoCode: "sn"
    },
    {
        language: "Sichuan Yi",
        isoCode: "ii"
    },
    {
        language: "Sindhi",
        isoCode: "sd"
    },
    {
        language: "Sinhalese",
        isoCode: "si"
    },
    {
        language: "Siswati",
        isoCode: "ss"
    },
    {
        language: "Slovak",
        isoCode: "sk"
    },
    {
        language: "Slovenian",
        isoCode: "sl"
    },
    {
        language: "Somali",
        isoCode: "so"
    },
    {
        language: "Southern Ndebele",
        isoCode: "nr"
    },
    {
        language: "Spanish",
        isoCode: "es"
    },
    {
        language: "Sundanese",
        isoCode: "su"
    },
    {
        language: "Swahili (Kiswahili)",
        isoCode: "sw"
    },
    {
        language: "Swati",
        isoCode: "ss"
    },
    {
        language: "Swedish",
        isoCode: "sv"
    },
    {
        language: "Tagalog",
        isoCode: "tl"
    },
    {
        language: "Tahitian",
        isoCode: "ty"
    },
    {
        language: "Tajik",
        isoCode: "tg"
    },
    {
        language: "Tamil",
        isoCode: "ta"
    },
    {
        language: "Tatar",
        isoCode: "tt"
    },
    {
        language: "Telugu",
        isoCode: "te"
    },
    {
        language: "Thai",
        isoCode: "th"
    },
    {
        language: "Tibetan",
        isoCode: "bo"
    },
    {
        language: "Tigrinya",
        isoCode: "ti"
    },
    {
        language: "Tonga",
        isoCode: "to"
    },
    {
        language: "Tsonga",
        isoCode: "ts"
    },
    {
        language: "Turkish",
        isoCode: "tr"
    },
    {
        language: "Turkmen",
        isoCode: "tk"
    },
    {
        language: "Twi",
        isoCode: "tw"
    },
    {
        language: "Uyghur",
        isoCode: "ug"
    },
    {
        language: "Ukrainian",
        isoCode: "uk"
    },
    {
        language: "Urdu",
        isoCode: "ur"
    },
    {
        language: "Uzbek",
        isoCode: "uz"
    },
    {
        language: "Venda",
        isoCode: "ve"
    },
    {
        language: "Vietnamese",
        isoCode: "vi"
    },
    {
        language: "Volap\xfck",
        isoCode: "vo"
    },
    {
        language: "Wallon",
        isoCode: "wa"
    },
    {
        language: "Welsh",
        isoCode: "cy"
    },
    {
        language: "Wolof",
        isoCode: "wo"
    },
    {
        language: "Western Frisian",
        isoCode: "fy"
    },
    {
        language: "Xhosa",
        isoCode: "xh"
    },
    {
        language: "Yiddish",
        isoCode: "yi, ji"
    },
    {
        language: "Yoruba",
        isoCode: "yo"
    },
    {
        language: "Zhuang, Chuang",
        isoCode: "za"
    },
    {
        language: "Zulu",
        isoCode: "zu"
    }
];
/* harmony default export */ __webpack_exports__["Z"] = (languageCode);


/***/ }),

/***/ 87127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ox": function() { return /* reexport */ currencyEnum; },
  "Zo": function() { return /* binding */ currencyList; },
  "Lp": function() { return /* binding */ feeTypeEnum; },
  "Y7": function() { return /* binding */ getCurrencyText; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/constants/currencyEnum.js
var currencyEnum = {
    FREE: 0,
    SGD: 1,
    USD: 2,
    TWD: 3,
    CNY: 4,
    EUR: 5,
    JPY: 6,
    0: "FREE",
    1: "SGD",
    2: "USD",
    3: "TWD",
    4: "CNY",
    5: "EUR",
    6: "JPY"
};

// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./src/utils/parse-currency.js


var parseCurrency = function(param) {
    var _param_currency = param.currency, currency = _param_currency === void 0 ? 1 : _param_currency, price = param.price;
    if (currency === 0) {
        return "FREE";
    }
    return "".concat(currencyEnum[currency], " ").concat(numeral_default()(price).format("0,0.[00]"));
};
/* harmony default export */ var parse_currency = (parseCurrency);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/constants/price-setting.js






var currencyList = [
    "SGD",
    "USD",
    "TWD",
    "CNY",
    "EUR",
    "JPY"
];
var feeTypeEnum = {
    free: 1,
    oneTimePayment: 2,
    bundlePrice: 3,
    1: "free",
    2: "oneTimePayment",
    3: "bundlePrice"
};
var getCurrencyText = function(props) {
    var feeType = props.feeType, price = props.price, currency = props.currency, intl = props.intl;
    switch(feeType){
        case feeTypeEnum.oneTimePayment:
            {
                return parse_currency((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    currency: currency,
                    price: price
                }));
            }
        case feeTypeEnum.bundlePrice:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    textDecorationLine: "line-through"
                },
                children: parse_currency((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    currency: currency,
                    price: price
                }))
            });
        case feeTypeEnum.free:
        default:
            return intl.formatMessage({
                id: "common.paymentType.free"
            });
    }
};



/***/ }),

/***/ 69690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C9": function() { return /* binding */ setDefaultCaption; },
/* harmony export */   "GW": function() { return /* binding */ postCaption; },
/* harmony export */   "Jc": function() { return /* binding */ getCaptionList; },
/* harmony export */   "Uc": function() { return /* binding */ putCaption; },
/* harmony export */   "bO": function() { return /* binding */ deleteCaptionPoint; },
/* harmony export */   "y5": function() { return /* binding */ getCaptionContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52157);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var querystringify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57129);
/* harmony import */ var subtitle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50506);






var getCaptionContent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(url) {
        var getData, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_1___default().get(url, {
                            transformRequest: [
                                function(data, headers) {
                                    // eslint-disable-next-line no-param-reassign
                                    delete headers.common.Authorization;
                                    if (data) {
                                        return data;
                                    }
                                    return null;
                                }
                            ]
                        })
                    ];
                case 1:
                    getData = _state.sent();
                    return [
                        2,
                        {
                            data: (0,subtitle__WEBPACK_IMPORTED_MODULE_5__/* .parse */ .Q)(getData.data)
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        error
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCaptionContent(url) {
        return _ref.apply(this, arguments);
    };
}();
var getNewCaptionList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(captionData) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            try {
                res = JSON.parse(JSON.stringify(captionData));
                captionData.data.captionList.forEach(function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(item, index) {
                        var _ref, data, _$error;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getCaptionContent(item.captionUrl)
                                    ];
                                case 1:
                                    _ref = _state.sent(), data = _ref.data, _$error = _ref.error;
                                    if (_$error) throw _$error;
                                    // TODO: consider maybe one of captionData url download filed
                                    res.data.captionList[index].captionContent = data;
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(item, index) {
                        return _ref.apply(this, arguments);
                    };
                }());
                return [
                    2,
                    res
                ];
            } catch (error) {
                console.error("getNewCaptionList", error);
                return [
                    2,
                    captionData
                ];
            }
            return [
                2
            ];
        });
    });
    return function getNewCaptionList(captionData) {
        return _ref.apply(this, arguments);
    };
}();
var getCaptionList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(videoId) {
        var type, _ref, resData, error, error1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    type = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "reference";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/studio/video/".concat(videoId, "/caption?type=").concat(type))
                    ];
                case 2:
                    _ref = _state.sent(), resData = _ref.data, error = _ref.error;
                    if (error) throw error;
                    return [
                        4,
                        getNewCaptionList(resData)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    error1 = _state.sent();
                    return [
                        2,
                        error1
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCaptionList(videoId) {
        return _ref.apply(this, arguments);
    };
}();
var postCaption = function(param) {
    var videoId = param.videoId, data = param.data, _param_type = param.type, type = _param_type === void 0 ? "reference" : _param_type, config = param.config;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/api/v1/studio/video/".concat(videoId, "/caption?type=").concat(type), data, config).then(function(response) {
        return response.data;
    });
};
var putCaption = function(param) {
    var videoId = param.videoId, data = param.data, _param_type = param.type, type = _param_type === void 0 ? "reference" : _param_type, config = param.config;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/api/v1/studio/video/".concat(videoId, "/caption?type=").concat(type), data, config).then(function(response) {
        return response.data;
    });
};
/**
 * @api {delete} /api/v1/studio/video/${videoId}/caption
 * @apiDescription delete caption
 */ var deleteCaptionPoint = function(props) {
    var videoId = props.videoId, language = props.language, _props_type = props.type, type = _props_type === void 0 ? "reference" : _props_type;
    var query = querystringify__WEBPACK_IMPORTED_MODULE_2__.stringify({
        type: type,
        language: language
    });
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"]("/api/v1/studio/video/".concat(videoId, "/caption?").concat(query)).then(function(response) {
        return response.data;
    });
};
/**
 * @api {put} api/v1/studio/video/caption/${videoId}
 * @apiDescription add assessment
 */ var setDefaultCaption = function(param) {
    var videoId = param.videoId, language = param.language, _param_type = param.type, type = _param_type === void 0 ? "reference" : _param_type;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/api/v1/studio/video/caption/".concat(videoId, "?type=").concat(type, "&language=").concat(language), {
        videoId: videoId,
        language: language
    }).then(function(response) {
        return response.data;
    });
};



/***/ }),

/***/ 80533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ postLikePoint; },
/* harmony export */   "CB": function() { return /* binding */ createQuestion; },
/* harmony export */   "LQ": function() { return /* binding */ recordLastWatchPoint; },
/* harmony export */   "Or": function() { return /* binding */ progressRecord; },
/* harmony export */   "PQ": function() { return /* binding */ getH5InfoPoint; },
/* harmony export */   "Pp": function() { return /* binding */ getLastWatchPoint; },
/* harmony export */   "RD": function() { return /* binding */ searchDiscussionPoint; },
/* harmony export */   "SZ": function() { return /* binding */ deleteReplyPoint; },
/* harmony export */   "UG": function() { return /* binding */ updateReplyPoint; },
/* harmony export */   "UH": function() { return /* binding */ getPreviewCaptionContent; },
/* harmony export */   "az": function() { return /* binding */ deleteQuestionPoint; },
/* harmony export */   "bp": function() { return /* binding */ addReplyPoint; },
/* harmony export */   "eT": function() { return /* binding */ getNoteList; },
/* harmony export */   "eb": function() { return /* binding */ getQuestionList; },
/* harmony export */   "f3": function() { return /* binding */ searchNotePoint; },
/* harmony export */   "f_": function() { return /* binding */ deleteNote; },
/* harmony export */   "fw": function() { return /* binding */ updateQuestionPoint; },
/* harmony export */   "h4": function() { return /* binding */ getRelatedInfoPoint; },
/* harmony export */   "kT": function() { return /* binding */ createNote; },
/* harmony export */   "kj": function() { return /* binding */ getDocumentInfoPoint; },
/* harmony export */   "kk": function() { return /* binding */ getReplyListPoint; },
/* harmony export */   "lO": function() { return /* binding */ getDiscussionPoint; },
/* harmony export */   "mp": function() { return /* binding */ getDocumentWatchDuration; },
/* harmony export */   "nE": function() { return /* binding */ getLearningVideoInfo; },
/* harmony export */   "sx": function() { return /* binding */ getLearningCaptionContent; },
/* harmony export */   "tw": function() { return /* binding */ postReplyHelpfulPoint; },
/* harmony export */   "u1": function() { return /* binding */ getNoteMarkerTimeList; },
/* harmony export */   "wI": function() { return /* binding */ saveNotePoint; },
/* harmony export */   "zC": function() { return /* binding */ getLatestWatchRecordPoint; }
/* harmony export */ });
/* unused harmony export getCourseCaptionLanguage */
/* harmony import */ var _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52157);
/* harmony import */ var querystringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57129);
// preview page client api here


var createNote = function(param) {
    var postData = param.postData;
    var videoId = postData.videoId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/api/v1/note/video/".concat(videoId, "/note"), postData).then(function(res) {
        return res.data;
    });
};
var createQuestion = function(param) {
    var postData = param.postData;
    var videoId = postData.videoId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/api/v1/forum/video/".concat(videoId, "/question"), postData).then(function(res) {
        return res.data;
    });
};
var getNoteList = function(postData) {
    var videoId = postData.videoId, startTime = postData.startTime, endTime = postData.endTime, _postData_pageNum = postData.pageNum, pageNum = _postData_pageNum === void 0 ? 0 : _postData_pageNum;
    var query = querystringify__WEBPACK_IMPORTED_MODULE_1__.stringify({
        pageNum: pageNum,
        startTime: startTime,
        endTime: endTime
    });
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/note/video/".concat(videoId, "/note?pageSize=7&sortKey=marker_time&sortOrder=-1&").concat(query)).then(function(res) {
        return res.data;
    });
};
var getNoteMarkerTimeList = function(postData) {
    var videoId = postData.videoId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/note/video/".concat(videoId, "/marker_time")).then(function(res) {
        return res.data;
    });
};
var getQuestionList = function(videoId) {
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/forum/video/".concat(videoId, "/question?pageNum=0&sortOrder=1&pageSize=200")).then(function(res) {
        return res.data;
    });
};
var deleteNote = function(videoId, noteId) {
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"]("/api/v1/note/video/".concat(videoId, "/note/").concat(noteId)).then(function(res) {
        return res.data;
    });
};
var saveNotePoint = function(videoId, noteId, postData) {
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/api/v1/note/video/".concat(videoId, "/note/").concat(noteId), postData).then(function(res) {
        return res.data;
    });
};
var addReplyPoint = function(postData) {
    var videoId = postData.videoId, questionId = postData.questionId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/api/v1/forum/video/".concat(videoId, "/question/").concat(questionId, "/reply"), postData).then(function(res) {
        return res.data;
    });
};
var getReplyListPoint = function(postData) {
    var videoId = postData.videoId, questionId = postData.questionId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/forum/video/".concat(videoId, "/question/").concat(questionId, "/reply?sortKey=create_time&sortOrder=-1&pageSize=200")).then(function(res) {
        return res.data;
    });
};
var updateQuestionPoint = function(postData) {
    var videoId = postData.videoId, questionId = postData.questionId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/api/v1/forum/video/".concat(videoId, "/question/").concat(questionId), postData).then(function(res) {
        return res.data;
    });
};
var deleteQuestionPoint = function(postData) {
    var videoId = postData.videoId, questionId = postData.questionId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"]("/api/v1/forum/video/".concat(videoId, "/question/").concat(questionId)).then(function(res) {
        return res.data;
    });
};
var postLikePoint = function(postData) {
    var itemType = postData.itemType, status = postData.status, itemId = postData.itemId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/api/v1/forum/like/".concat(itemType, "?status=").concat(status, "&itemId=").concat(itemId), postData).then(function(res) {
        return res.data;
    });
};
var updateReplyPoint = function(postData) {
    var videoId = postData.videoId, replyId = postData.replyId, questionId = postData.questionId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/api/v1/forum/video/".concat(videoId, "/question/").concat(questionId, "/reply/").concat(replyId), postData).then(function(res) {
        return res.data;
    });
};
var deleteReplyPoint = function(postData) {
    var videoId = postData.videoId, questionId = postData.questionId, replyId = postData.replyId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"]("/api/v1/forum/video/".concat(videoId, "/question/").concat(questionId, "/reply/").concat(replyId)).then(function(res) {
        return res.data;
    });
};
var postReplyHelpfulPoint = function(postData) {
    var videoId = postData.videoId, questionId = postData.questionId, replyId = postData.replyId, status = postData.status;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/api/v1/forum/video/".concat(videoId, "/question/").concat(questionId, "/reply/").concat(replyId, "/helpful?status=").concat(status), {}).then(function(res) {
        return res.data;
    });
};
var progressRecord = function(postData) {
    var itemId = postData.itemId, startIndex = postData.startIndex, endIndex = postData.endIndex, itemType = postData.itemType;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/api/v1/learning-system/".concat(itemType, "/").concat(itemId, "/action?startIndex=").concat(startIndex, "&endIndex=").concat(endIndex), {}).then(function(res) {
        return res.data;
    });
};
var getLearningVideoInfo = function(videoId) {
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/learning-system/video/".concat(videoId)).then(function(res) {
        return res.data;
    });
};
var getLearningCaptionContent = function(videoId) {
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/learning-system/video/".concat(videoId, "/caption")).then(function(res) {
        return res.data;
    });
};
var getPreviewCaptionContent = function(videoId) {
    var query = querystringify__WEBPACK_IMPORTED_MODULE_1__.stringify({
        videoId: videoId
    });
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/catalog/preview/video_caption?".concat(query)).then(function(res) {
        return res.data;
    });
};
var getCourseCaptionLanguage = function(param) {
    var courseId = param.courseId;
    var query = qs.stringify({
        courseId: courseId
    });
    return clientAPI.get("/api/v1/catalog/course/caption/language?".concat(query)).then(function(res) {
        return res.data;
    });
};
var recordLastWatchPoint = function(postData) {
    var courseId = postData.courseId, type = postData.learningType, contentId = postData.learningItemId;
    var query = querystringify__WEBPACK_IMPORTED_MODULE_1__.stringify({
        courseId: courseId,
        type: type,
        contentId: contentId
    });
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/api/v1/learning-system/latest/watch?".concat(query)).then(function(res) {
        return res.data;
    });
};
var getLastWatchPoint = function() {
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/learning-system/course/latest/watch").then(function(res) {
        return res.data;
    });
};
var searchDiscussionPoint = function(postData) {
    var videoId = postData.videoId, keyword = postData.keyword;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/forum/search/video/".concat(videoId, "/discussion?keyWord=").concat(keyword, "&sortOrder=-1&pageSize=200")).then(function(res) {
        return res.data;
    });
};
var getRelatedInfoPoint = function(postData) {
    var videoId = postData.videoId, courseId = postData.courseId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/search/recommendation/related_course?videoId=".concat(videoId, "&courseId=").concat(courseId)).then(function(res) {
        return res.data;
    });
};
var getDocumentInfoPoint = function(docId) {
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/learning-system/doc/".concat(docId)).then(function(res) {
        return res.data;
    });
};
var getLatestWatchRecordPoint = function(postData) {
    var courseId = postData.courseId, contentType = postData.contentType, contentId = postData.contentId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/learning-system/latest/watch/record?courseId=".concat(courseId, "&contentType=").concat(contentType, "&contentId=").concat(contentId)).then(function(res) {
        return res.data;
    });
};
var getH5InfoPoint = function(h5Id) {
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/learning-system/h5/".concat(h5Id)).then(function(res) {
        return res.data;
    });
};
/**
 * @api /api/v1/learning-system/doc/{docId}
 * @apiDescription get doc info
 */ var getDocumentWatchDuration = function(param) {
    var documentId = param.documentId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/learning-system/doc/watch/".concat(documentId)).then(function(response) {
        return response.data;
    });
};
/**
 * @api /api/v1/forum/video/{videoId}/question/{questionId}
 * @apiDescription get discussion
 */ var getDiscussionPoint = function(param) {
    var videoId = param.videoId, questionId = param.questionId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/forum/video/".concat(videoId, "/question/").concat(questionId)).then(function(response) {
        return response.data;
    });
};
var searchNotePoint = function(postData) {
    var videoId = postData.videoId, keyword = postData.keyword;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/v1/note/video/".concat(videoId, "/note?keyWord=").concat(keyword, "&sortOrder=-1")).then(function(res) {
        return res.data;
    });
};



/***/ }),

/***/ 76932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kz": function() { return /* binding */ dateISOFormat; },
/* harmony export */   "Th": function() { return /* binding */ dateFormatValue; },
/* harmony export */   "d_": function() { return /* binding */ translateMomentLocale; },
/* harmony export */   "uX": function() { return /* binding */ formatToSeconds; },
/* harmony export */   "vc": function() { return /* binding */ dateFormat; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1646);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56176);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29387);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70178);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_4__);






__webpack_require__.e(/* import() */ 3901).then(__webpack_require__.t.bind(__webpack_require__, 43901, 23));
__webpack_require__.e(/* import() */ 3852).then(__webpack_require__.t.bind(__webpack_require__, 33852, 23));
dayjs__WEBPACK_IMPORTED_MODULE_0__.extend(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_3__);
dayjs__WEBPACK_IMPORTED_MODULE_0__.extend(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_1__);
dayjs__WEBPACK_IMPORTED_MODULE_0__.extend(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_4__);
dayjs__WEBPACK_IMPORTED_MODULE_0__.extend(dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_2__);
var formatToSeconds = function(markerTime) {
    var durationSplit = markerTime.split(":");
    var _durationSplit = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(durationSplit, 3), hours = _durationSplit[0], minutes = _durationSplit[1], seconds = _durationSplit[2];
    if (durationSplit.length === 3) {
        return Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds);
    }
    if (durationSplit.length === 2) {
        return Number(hours) * 60 + Number(minutes);
    }
    return 0;
};
var translateMomentLocale = function(localeValue) {
    switch(localeValue){
        case "zh-Hant":
            return "zh-tw";
        case "zh-Hans":
            return "zh-cn";
        default:
            return "en";
    }
};
var dateFormat = function(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0__(date).format("YYYY-MM-DD");
};
var dateISOFormat = function(date) {
    return new Date(dayjs__WEBPACK_IMPORTED_MODULE_0__(date).format("YYYY-MM-DD")).toISOString();
};
var dateFormatValue = function(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0__(date, "YYYY-MM-DD").valueOf;
};
/* harmony default export */ __webpack_exports__["ZP"] = (dayjs__WEBPACK_IMPORTED_MODULE_0__);


/***/ }),

/***/ 78761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useFormatDuration; }
/* harmony export */ });
/* harmony import */ var _utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76932);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86896);


var useFormatDuration = function() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var _intl_locale = intl.locale, locale = _intl_locale === void 0 ? "en" : _intl_locale;
    return function(durationString) {
        var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "minutes";
        var duration = parseInt(durationString, 10);
        if (!durationString || Number.isNaN(duration)) {
            return "0".concat(unit === "seconds" ? intl.formatMessage({
                id: "common.duration.seconds",
                defaultMessage: "s"
            }) : intl.formatMessage({
                id: "common.duration.minutes",
                defaultMessage: "m"
            }));
        }
        var hours = Math.floor(_utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"].duration */ .ZP.duration(durationString, unit).asHours());
        var minutes = Math.floor(_utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"].duration */ .ZP.duration(durationString, unit).get("minutes"));
        var seconds = Math.floor(_utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"].duration */ .ZP.duration(durationString, unit).get("seconds"));
        var hoursString = hours > 0 ? hours + intl.formatMessage({
            id: "common.duration.hours",
            defaultMessage: "h"
        }) : "";
        var minutesString = minutes > 0 ? minutes + intl.formatMessage({
            id: "common.duration.minutes",
            defaultMessage: "m"
        }) : "";
        var secondsString = seconds > 0 ? seconds + intl.formatMessage({
            id: "common.duration.seconds",
            defaultMessage: "s"
        }) : "";
        return [
            hoursString,
            minutesString,
            secondsString
        ].join(locale === "en" ? " " : "").trim();
    };
};


/***/ }),

/***/ 23615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A7": function() { return /* binding */ transferLanguage; },
/* harmony export */   "M7": function() { return /* binding */ mapRoleToIntlKey; },
/* harmony export */   "Xo": function() { return /* binding */ existedLanguage; },
/* harmony export */   "Xu": function() { return /* binding */ mapDashboardToIntlKey; }
/* harmony export */ });
/* harmony import */ var _constants_language_code__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66280);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9280);


var isIsoTarget = function(languageCode) {
    return function(element) {
        return element.isoCode.toLowerCase().replace(/ /g, "").split(",").indexOf(languageCode === null || languageCode === void 0 ? void 0 : languageCode.toLowerCase()) >= 0;
    };
};
var transferLanguage = function(languageCode) {
    if (languageCode) {
        var filterRes = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hXT)(isIsoTarget(languageCode), _constants_language_code__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
        var res = filterRes.length ? filterRes[0].language : "-";
        return res;
    }
    return "-";
};
var existedLanguage = function(languageCode) {
    var filterRes = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hXT)(isIsoTarget(languageCode), _constants_language_code__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
    return filterRes.length > 0;
};
var mapRoleToIntlKey = {
    admin: "console.role.admin",
    provider: "console.role.provider",
    editor: "console.role.editor",
    instructor: "console.role.instructor",
    learner: "console.role.learner"
};
var mapDashboardToIntlKey = {
    login: "dashboard.dataKey.login",
    activelyLearner: "dashboard.dataKey.activelyLearner",
    registered: "dashboard.dataKey.registered",
    videoContent: "dashboard.dataKey.videoContent",
    documentContent: "dashboard.dataKey.documentContent",
    assessmentContent: "dashboard.dataKey.assessmentContent",
    h5Content: "dashboard.dataKey.h5Content",
    askedQuestion: "dashboard.dataKey.askedQuestion",
    repliedQuestion: "dashboard.dataKey.repliedQuestion",
    approval: "dashboard.dataKey.approval",
    helpful: "dashboard.dataKey.helpful",
    usedImportantMarker: "dashboard.dataKey.usedImportantMarker",
    madeNote: "dashboard.dataKey.madeNote",
    usedSectionMarker: "dashboard.dataKey.usedSectionMarker",
    usedQuestionMarkerOnPlay: "dashboard.dataKey.usedQuestionMarkerOnPlay",
    usedQuestionMarkerOnMiniPlay: "dashboard.dataKey.usedQuestionMarkerOnMiniPlay",
    learnerView: "dashboard.dataKey.learnerView",
    completion: "dashboard.dataKey.completion",
    visitorView: "dashboard.dataKey.visitorView",
    enrolled: "dashboard.dataKey.enrolled",
    totalEnrollmentUser: "dashboard.dataKey.totalEnrollmentUser",
    completeUserCount: "dashboard.dataKey.completeUserCount",
    progressUserCount: "dashboard.dataKey.progressUserCount",
    notStartUserCount: "dashboard.dataKey.notStartUserCount",
    likeCount: "dashboard.dataKey.likeCount",
    shareCount: "dashboard.dataKey.shareCount",
    videoBar: "dashboard.dataKey.videoBar",
    documentBar: "dashboard.dataKey.documentBar",
    assessmentBar: "dashboard.dataKey.assessmentBar",
    h5Bar: "dashboard.dataKey.h5Bar"
};


/***/ }),

/***/ 98373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mg": function() { return /* binding */ numberAbbr; },
/* harmony export */   "Vf": function() { return /* binding */ dashboardNum; },
/* harmony export */   "WG": function() { return /* binding */ percentNum; },
/* harmony export */   "ao": function() { return /* binding */ formatNum; },
/* harmony export */   "cI": function() { return /* binding */ formatTwoDigit; },
/* harmony export */   "uL": function() { return /* binding */ padTwoDigit; }
/* harmony export */ });
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);

var formatNum = function(value) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).format("0,0");
};
var numberAbbr = function(value) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0a";
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).format(format);
};
var percentNum = function(value) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).format("0.0%");
};
var formatTwoDigit = function(value) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).format("00");
};
var dashboardNum = function(value) {
    return value >= 1000000 ? numberAbbr(value, "0.00000a") : formatNum(value);
};
var padTwoDigit = function(num) {
    if (num === 0) {
        return "0";
    }
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(num).format("00");
};


/***/ }),

/***/ 62802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ getVideoInfo; },
/* harmony export */   "FN": function() { return /* binding */ leftPercent; },
/* harmony export */   "FY": function() { return /* binding */ calcLeft; },
/* harmony export */   "KT": function() { return /* binding */ getCaption; },
/* harmony export */   "RK": function() { return /* binding */ calcFiveSecondsWidth; },
/* harmony export */   "UC": function() { return /* binding */ sectionMarkerPlayed; },
/* harmony export */   "VE": function() { return /* binding */ filterCourseInfoItem; },
/* harmony export */   "W6": function() { return /* binding */ matchNoteRangeFunction; },
/* harmony export */   "XU": function() { return /* binding */ transferDurationMilliseconds; },
/* harmony export */   "Yd": function() { return /* binding */ findSectionRelevantItem; },
/* harmony export */   "Zg": function() { return /* binding */ transferSeekRatio; },
/* harmony export */   "e3": function() { return /* binding */ matchRangeFunction; },
/* harmony export */   "gQ": function() { return /* binding */ syncCourseData; },
/* harmony export */   "v$": function() { return /* binding */ groupCaptionBySection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var _utils_apiServices_caption__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69690);
/* harmony import */ var _utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76932);
/* harmony import */ var _utils_language_transfer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9280);
/* harmony import */ var _apiServices_preview__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80533);










/**
 * allowExceedLimit
 * Not limited by the time between the beginning and the end of the section.
 */ var allowLimitExceed = false;
var isMatchLimit = function(param) {
    var targetTime = param.targetTime, sectionMaxLimit = param.sectionMaxLimit, sectionMinLimit = param.sectionMinLimit, isLastSection = param.isLastSection;
    var isFirstSection = sectionMinLimit === 0;
    if (isFirstSection) {
        return allowLimitExceed ? targetTime < sectionMaxLimit : targetTime < sectionMaxLimit && targetTime >= sectionMinLimit;
    }
    if (isLastSection) {
        return allowLimitExceed ? targetTime >= sectionMinLimit : targetTime <= sectionMaxLimit && targetTime >= sectionMinLimit;
    }
    return targetTime < sectionMaxLimit && targetTime >= sectionMinLimit;
};
var getSectionLimit = function(param) {
    var index = param.index, _param_sectionMarkerList = param.sectionMarkerList, sectionMarkerList = _param_sectionMarkerList === void 0 ? [] : _param_sectionMarkerList, playedSeconds = param.playedSeconds, isLastSection = param.isLastSection;
    var maxTemp = 0;
    var minTemp = 0;
    sectionMarkerList.forEach(function(item, flag) {
        if (flag <= index) maxTemp += item.widthRatio;
    });
    sectionMarkerList.forEach(function(item, flag) {
        if (flag <= index - 1) minTemp += item.widthRatio;
    });
    var sectionMinLimit = parseInt(minTemp * playedSeconds / 100, 10);
    var maxLimit = maxTemp * playedSeconds / 100;
    var sectionMaxLimit = isLastSection ? parseInt(Math.round(maxLimit), 10) + 1 : parseInt(maxLimit, 10);
    return {
        sectionMinLimit: sectionMinLimit,
        sectionMaxLimit: sectionMaxLimit
    };
};
var calcLeft = function(markerTime, totalDuration, videoWidth, maxLeft) {
    var left = (0,_utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_1__/* .formatToSeconds */ .uX)(markerTime) / parseInt(_utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].duration */ .ZP.duration(totalDuration * 1000).asSeconds(), 10) * videoWidth;
    if (left >= videoWidth) {
        left = maxLeft;
    }
    return left;
};
var leftPercent = function(markerTime, totalDuration) {
    return (0,_utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_1__/* .formatToSeconds */ .uX)(markerTime) / parseInt(_utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].duration */ .ZP.duration(totalDuration * 1000).asSeconds(), 10) * 100;
};
var calcFiveSecondsWidth = function(videoWidth, totalDuration) {
    return videoWidth / _utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].duration */ .ZP.duration(totalDuration * 1000).asSeconds() * 5;
};
var transferDurationMilliseconds = function(duration) {
    return (0,_utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_1__/* .formatToSeconds */ .uX)(duration) * 1000;
};
var transferSeekRatio = function(currentTime, totalDuration) {
    if (currentTime === 0 || totalDuration === 0) {
        return 0;
    }
    if (currentTime > totalDuration) {
        console.error("transferSeekRatio currentTime > totalDuration");
    }
    var total = Math.floor(parseFloat(totalDuration));
    var result = currentTime / total;
    return result;
};
var matchRangeFunction = function(markerTime, start, end) {
    return markerTime >= start && markerTime < end;
};
var getVideoInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(learningItemId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            return [
                2,
                (0,_apiServices_preview__WEBPACK_IMPORTED_MODULE_4__/* .getLearningVideoInfo */ .nE)(learningItemId)
            ];
        });
    });
    return function getVideoInfo(learningItemId) {
        return _ref.apply(this, arguments);
    };
}();
var getLocalStorageLanguageSetting = function(param) {
    var setCaptionOn = param.setCaptionOn, setCaptionLanguage = param.setCaptionLanguage, _param_captionInfoList = param.captionInfoList, captionInfoList = _param_captionInfoList === void 0 ? [] : _param_captionInfoList;
    var showCaption = JSON.parse(localStorage.getItem("showCaption"));
    var lastCaptionLanguage = JSON.parse(localStorage.getItem("lastCaptionLanguage"));
    if (showCaption === true) {
        setCaptionOn(true);
    } else if (showCaption === false) {
        setCaptionOn(false);
    }
    if (lastCaptionLanguage && captionInfoList.findIndex(function(caption) {
        return caption.language === lastCaptionLanguage;
    }) !== -1) {
        setCaptionLanguage(lastCaptionLanguage);
    }
};
var getCaption = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var learningItemId, userLanguage, setRenderCaptionList, setCaptionLanguageOptions, setCaptionOn, setCaptionLanguage, getCaptionApi, captionInfoList, data, data1, tempCaptionOption;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    learningItemId = param.learningItemId, userLanguage = param.userLanguage, setRenderCaptionList = param.setRenderCaptionList, setCaptionLanguageOptions = param.setCaptionLanguageOptions, setCaptionOn = param.setCaptionOn, setCaptionLanguage = param.setCaptionLanguage, getCaptionApi = param.getCaptionApi;
                    captionInfoList = [];
                    if (!getCaptionApi) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getCaptionApi(learningItemId)
                    ];
                case 1:
                    data = _state.sent().data;
                    captionInfoList = data.captionList || data;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        (0,_apiServices_preview__WEBPACK_IMPORTED_MODULE_4__/* .getLearningCaptionContent */ .sx)(learningItemId)
                    ];
                case 3:
                    data1 = _state.sent().data;
                    captionInfoList = data1.captionList;
                    _state.label = 4;
                case 4:
                    if (captionInfoList === null || captionInfoList === void 0 ? void 0 : captionInfoList.length) {
                        tempCaptionOption = captionInfoList.map(function(item, index) {
                            var isDefaultLang = item.flag === "true";
                            if (isDefaultLang) setCaptionLanguage(item.language); // provider default language
                            var labelRender = "".concat((0,_utils_language_transfer__WEBPACK_IMPORTED_MODULE_2__/* .transferLanguage */ .A7)(item.language)).concat(isDefaultLang ? "(Default)" : "");
                            return {
                                value: item.language,
                                label: labelRender,
                                index: index
                            };
                        });
                        if (captionInfoList.every(function(item) {
                            return item.flag === "false";
                        })) {
                            setCaptionLanguage(captionInfoList[0].language);
                        }
                        captionInfoList.forEach(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(item) {
                                var _ref, captionContent;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!item.captionUrl) {
                                                setRenderCaptionList(function(prev) {
                                                    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(prev).concat([
                                                        {
                                                            language: item.language,
                                                            caption: []
                                                        }
                                                    ]);
                                                });
                                            }
                                            return [
                                                4,
                                                (0,_utils_apiServices_caption__WEBPACK_IMPORTED_MODULE_0__/* .getCaptionContent */ .y5)(item.captionUrl)
                                            ];
                                        case 1:
                                            _ref = _state.sent(), captionContent = _ref.data;
                                            setRenderCaptionList(function(prev) {
                                                return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(prev).concat([
                                                    {
                                                        language: item.language,
                                                        caption: captionContent
                                                    }
                                                ]);
                                            });
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(item) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        setCaptionLanguageOptions(tempCaptionOption);
                        if (userLanguage && captionInfoList.findIndex(function(caption) {
                            return caption.language === userLanguage;
                        }) !== -1) {
                            setCaptionLanguage(userLanguage);
                        }
                        getLocalStorageLanguageSetting({
                            setCaptionOn: setCaptionOn,
                            setCaptionLanguage: setCaptionLanguage,
                            captionInfoList: captionInfoList
                        });
                    } else {
                        setCaptionLanguageOptions([]);
                        setRenderCaptionList([]);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function getCaption(_) {
        return _ref.apply(this, arguments);
    };
}();
var matchNoteRangeFunction = function(markerTime, start, end) {
    var transferToFloorMillionSeconds = function(time) {
        return Math.floor(time / 1000) * 1000;
    };
    return markerTime >= transferToFloorMillionSeconds(start) && markerTime < transferToFloorMillionSeconds(end);
};
var findSectionRelevantCaption = function(index, renderSectionMarker, viewCaptionList, playedSeconds) {
    var res = [];
    var isLastSection = renderSectionMarker.length - 1 === index;
    var _getSectionLimit = getSectionLimit({
        index: index,
        sectionMarkerList: renderSectionMarker,
        playedSeconds: playedSeconds,
        isLastSection: isLastSection
    }), sectionMaxLimit = _getSectionLimit.sectionMaxLimit, sectionMinLimit = _getSectionLimit.sectionMinLimit;
    viewCaptionList === null || viewCaptionList === void 0 ? void 0 : viewCaptionList.forEach(function(item) {
        var targetTime = item.start / 1000;
        if (isMatchLimit({
            targetTime: targetTime,
            sectionMaxLimit: sectionMaxLimit,
            sectionMinLimit: sectionMinLimit,
            isLastSection: isLastSection
        })) {
            res.push(item);
        }
    });
    return res;
};
var groupCaptionBySection = function(renderSectionMarker, viewCaptionList, duration) {
    if (viewCaptionList === null || viewCaptionList === void 0 ? void 0 : viewCaptionList.length) {
        return renderSectionMarker === null || renderSectionMarker === void 0 ? void 0 : renderSectionMarker.map(function(item, index) {
            return findSectionRelevantCaption(index, renderSectionMarker, viewCaptionList, duration);
        });
    }
    return [];
};
var findSectionRelevantItem = function(index, sectionMarkerList, itemList, playedSeconds) {
    var res = [];
    var isLastSection = index === sectionMarkerList.length - 1;
    var _getSectionLimit = getSectionLimit({
        index: index,
        sectionMarkerList: sectionMarkerList,
        playedSeconds: playedSeconds,
        isLastSection: isLastSection
    }), sectionMaxLimit = _getSectionLimit.sectionMaxLimit, sectionMinLimit = _getSectionLimit.sectionMinLimit;
    itemList.forEach(function(item) {
        var targetTime = (0,_utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_1__/* .formatToSeconds */ .uX)(item.markerTime);
        if (isMatchLimit({
            targetTime: targetTime,
            sectionMaxLimit: sectionMaxLimit,
            sectionMinLimit: sectionMinLimit,
            isLastSection: isLastSection
        })) {
            res.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, item), {
                markerSecondsTime: (0,_utils_dayjs_utils__WEBPACK_IMPORTED_MODULE_1__/* .formatToSeconds */ .uX)(item.markerTime)
            }));
        }
    });
    var sortByMarkerTime = (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .sortWith */ .HCG)([
        (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .ascend */ .zU3)((0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .prop */ .vgT)("markerSecondsTime"))
    ]);
    return sortByMarkerTime(res);
};
/**
 *
 * @param infoData: course info data
 * @param removeItem: remove chapter or content item
 * @returns filter result
 */ var filterCourseInfoItem = function(infoData, removeItem) {
    var getResultChapter = function(result) {
        return result.courseContent.chapters;
    };
    var filterChapter = function(result, removeChapter) {
        var chapterId = (removeChapter || {}).chapterId;
        var contentChaptersInfo = result.courseContent.chapters;
        var removeChapterTarget = function(n) {
            return n.id !== chapterId;
        };
        var filterChapterResult = (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hXT)(removeChapterTarget, contentChaptersInfo);
        var temp = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, result);
        temp.courseContent.chapters = filterChapterResult;
        return temp;
    };
    var filterContent = function(result, removeContent) {
        var temp = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, result);
        var _ref = removeContent || {}, contentChapterId = _ref.chapterId, contentId = _ref.id;
        var removeContentChapterTarget = function(n) {
            return n.id === contentChapterId;
        };
        var contentChapterIndex = (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .findIndex */ .cxD)((0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .propEq */ .OH4)("id", contentChapterId))(getResultChapter(result));
        var removeContentTarget = function(n) {
            return n.id !== contentId;
        };
        var catchContentChapter = (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hXT)(removeContentChapterTarget, getResultChapter(result))[0];
        var catchContent = catchContentChapter && (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hXT)(removeContentTarget, catchContentChapter.items);
        if (catchContent === null || catchContent === void 0 ? void 0 : catchContent.length) {
            temp.courseContent.chapters[contentChapterIndex].items = catchContent;
        }
        return temp;
    };
    var result = infoData;
    if ((removeItem === null || removeItem === void 0 ? void 0 : removeItem.itemType) === "chapter") {
        result = filterChapter(result, removeItem);
    }
    if ((removeItem === null || removeItem === void 0 ? void 0 : removeItem.itemType) === "content") {
        result = filterContent(result, removeItem);
    }
    return result;
};
var syncCourseData = function(courseInfoData) {
    var prevCourseData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, isRefreshPage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (prevCourseData && !isRefreshPage) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, courseInfoData === null || courseInfoData === void 0 ? void 0 : courseInfoData.courseInfo, courseInfoData === null || courseInfoData === void 0 ? void 0 : courseInfoData.courseContent, {
            description: prevCourseData.description
        }, {
            title: prevCourseData.title
        }, {
            duration: prevCourseData.duration
        }), {
            courseCertificate: courseInfoData === null || courseInfoData === void 0 ? void 0 : courseInfoData.courseCertificate
        });
    }
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, courseInfoData === null || courseInfoData === void 0 ? void 0 : courseInfoData.courseInfo, courseInfoData === null || courseInfoData === void 0 ? void 0 : courseInfoData.courseContent), {
        courseCertificate: courseInfoData === null || courseInfoData === void 0 ? void 0 : courseInfoData.courseCertificate
    });
};
var sectionMarkerPlayed = function(videoInfoData) {
    var res = [];
    if (videoInfoData.sectionMarkers) {
        var playedCount = 0;
        videoInfoData.sectionMarkers.forEach(function(item) {
            playedCount += item.widthRatio;
            res.push(playedCount);
        });
    }
    return res;
};


/***/ })

}]);